import * as miniProgramApi from './miniprogram';

import * as nativeApi from './native';

const APIS = {
  // miniapp
  miniProgram: {
    ...miniProgramApi,
    navigateBackMiniProgram() {},
    onWebviewEvent() {},
    offWebviewEvent() {},
    sendWebviewEvent() {},
    onShow() {},
    onHide() {},
    onUnload() {}
  },

  // H5 invoke Native
  ...nativeApi,
};

export default APIS;
